import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { AppWrap, MotionWrap } from "../../wrapper";

import "./About.scss";

import { urlFor, client } from "./../../client";

const About = () => {
  const [abouts, setAbouts] = useState([]);

  useEffect(() => {
    const query = '*[_type == "abouts"]';

    client.fetch(query).then((data) => setAbouts(data));
  }, []);

  return (
    <section className="relative">
      <div className="gradient dark:opacity-10"></div>
      <h2 className="head-text dark:text-slate-50 ">
        I know That{" "}
        <span className="dark:text-transparent dark:bg-clip-text dark:bg-gradient-to-r from-[#007991] to-[#78ffd6]">
          Good Apps
        </span>{" "}
        <br />
        means{" "}
        <span className="dark:text-transparent dark:bg-clip-text dark:bg-gradient-to-r from-[#007991] to-[#78ffd6]">
          Good Business
        </span>{" "}
      </h2>

      <div className="app__profiles relative">
        <div className="absolute hidden sm:block w-[450px] h-[50%] sm:h-[70%] bottom-0 right-32 dark:blur-[175px] dark:bg-[#7562E2] dark:bg-opacity-60"></div>
        {abouts.map((about, index) => (
          <motion.div
            whileInView={{ opacity: 1 }}
            whileHover={{ scale: 1.1 }}
            transition={{ duration: 0.5, type: "tween" }}
            className="app__profile-item"
            key={about.title + index}
          >
            <img src={urlFor(about.imgUrl)} alt={about.title} />
            <h2
              className="bold-text dark:text-slate-50"
              style={{ marginTop: 20 }}
            >
              {about.title}
            </h2>
            <p className="p-text dark:text-slate-400" style={{ marginTop: 10 }}>
              {about.description}
            </p>
          </motion.div>
        ))}
      </div>
    </section>
  );
};

export default AppWrap(
  MotionWrap(About, "app__about"),
  "about",
  "app__whitebg dark:bg-darktheme dark:transition-all"
);
